import { createContext, useContext } from 'react';
import { identity } from 'ramda';
import { createDynamicContext } from 'js/store/helpers';

export const PortletContext = createContext({});

export const usePortletConfig = () => useContext(PortletContext);

export const {
    withDynamicReducer,
    useDynamicReducerSelector: usePortletSelector,
    useDynamicReducerDispatch: usePortletDispatch
} = createDynamicContext('Portlet', { reducer: identity });
